// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3hx76","gfeWrapper":"CalendarEvent_gfeWrapper__2KH6E"};